// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Where a Control message write goes when NO `ControlRoute` matches it.
 *
 * `MergePolicy` above governs the *read* direction — how differing values from
 * several MERGE/MIXED endpoints are reconciled. This enum is its write-direction
 * counterpart: on a merged channel a Control command must reach a specific
 * endpoint, and until now nothing on the wire said which.
 *
 * Per-control rules live in `ControlRoute` (see `control_route.fbs`). This
 * channel-level mode is the fallback for every Control value that no rule names.
 *
 * ACTIVE_ENDPOINT (0) — write to `Channel.active_endpoint_id`. This is the
 *                       pre-existing behaviour, and value 0 so that a channel
 *                       written without an explicit mode decodes as back-compat.
 *                       Existing MERGE channels with zero rules are unaffected.
 * PRIMARY_ENDPOINT (1) — write to the lowest (`group_id`, `priority`) endpoint,
 *                       regardless of which endpoint is currently active.
 * DROP (2)            — write nowhere and log a warning. Use when a merged
 *                       channel must never receive an unrouted command.
 */
export enum ControlWriteMode {
  ACTIVE_ENDPOINT = 0,
  PRIMARY_ENDPOINT = 1,
  DROP = 2,
}
